module.exports = __webpack_public_path__ + "static/divider1-78ae8f47d33bb8622dbf7062b4068ca0.svg";